import { render, staticRenderFns } from "./dataV.vue?vue&type=template&id=65a5ec76&scoped=true&"
import script from "./dataV.vue?vue&type=script&lang=js&"
export * from "./dataV.vue?vue&type=script&lang=js&"
import style0 from "./dataV.vue?vue&type=style&index=0&id=65a5ec76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5ec76",
  null
  
)

export default component.exports